import { Controller } from "react-hook-form";
import { FontEnum } from "../../utils/enums/FontEnum";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";

const ControllerSelect = ({
  defaultValue,
  name,
  control,
  options,
  placeholder,
  width = 254,
  disabled,
  endAdornment,
  externalOnChange,
  styleForLabel = {},  
  styleForSelect = {}, 
}) => {

  const getStyleForLabel = () => {
    return {
      ...styles.labelText,
      ...styleForLabel,
    };
  };

  const getStyleForSelect = () => {
    return {
      width,
      ...styleForSelect, 
    };
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? ""}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error}>
          <InputLabel sx={getStyleForLabel()}>
            {placeholder}
          </InputLabel>
          <Select
            {...field}
            id={name}
            sx={getStyleForSelect()} 
            onChange={(e) => {
              if (externalOnChange) {
                externalOnChange(e.target.value);
              }
              field.onChange(e);
            }}
            disabled={disabled}
            endAdornment={endAdornment}
            label={placeholder}
          >
            {options?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {fieldState.error && (
            <FormHelperText>
              {fieldState.error.message}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default ControllerSelect;

const styles = {
  labelText: {
    fontFamily: FontEnum.TITILIUM_WEB,
    fontSize: "15px",
    fontWeight: 400,
    color: "#00000099",
  },
};
